import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {showHome as showHomeNavigation} from '../../modules/Navigation';

const TagBreadcrumb = ({tag, widget, context, showHome}) => {
  const onClick = (e) => {
    e.preventDefault();
    showHome(widget, context);
  };

  return (
    <div className="tag-breadcrumb">
      <h2 className="tag-breadcrumb__heading">Topic</h2>
      <a className="tag-breadcrumb__tag" href="/answers" onClick={onClick} >
        {tag}
        <div className="tag-breadcrumb__icon">
          <i className="icon-close icon-sm icon-gray" />
          <i className="icon-close icon-sm icon-red" />
        </div>
      </a>
    </div>
  );
};

TagBreadcrumb.propTypes = {
  tag: PropTypes.string,
  widget: PropTypes.bool,
  context: PropTypes.string,
  showHome: PropTypes.func,
};

export default connect(
  (state) => ({
    widget: state.environment.widget,
    context: state.environment.widgetConfig.context,
  }),
  {showHome: showHomeNavigation}
)(TagBreadcrumb);
